import React, { useRef, useEffect, useState } from 'react';
import styles from './Modal.module.scss';
import Close from 'assets/icons/closeIcon.svg?react';
import { useTour } from '@reactour/tour';
import { createPortal } from 'react-dom';

function Modal({ isModalOpen = true, onClose, children, extraClass, colorBgSwitcher, ...rest }) {
  const modalContentRef = useRef(null);
  const containerRef = useRef(null);
  const [isClosing, setIsClosing] = useState(false);
  const { isOpen } = useTour();

  useEffect(() => {
    if (extraClass !== 'ImageCropModal' && !isOpen && isModalOpen && containerRef.current) {
      containerRef.current.classList.add(styles.popOut);
    }
  }, [isModalOpen, extraClass]);

  useEffect(() => {
    const handleCloseAnimationEnd = () => {
      setIsClosing(false);
      onClose();
    };

    if (isClosing && containerRef.current) {
      containerRef.current.classList.add(styles.closeModal);
      containerRef.current.addEventListener('animationend', handleCloseAnimationEnd);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('animationend', handleCloseAnimationEnd);
      }
    };
  }, [isClosing, onClose]);

  // Effect for outside click handling
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
        setIsClosing(true);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (!isModalOpen) return null;

  const modalRoot = document.getElementById('modal-root')

  const modal = (
    <div ref={containerRef} className={styles['modal-overlay']} style={rest.overlayStyle}>
      <div className={styles.backdrop} />
      <div
        style={rest.contentStyle}
        className={`${styles.modalContent} ${styles[extraClass]} ${colorBgSwitcher ? styles[`bg-${colorBgSwitcher}`] : ''
          }`}
        ref={modalContentRef}
      >
        <button
          className={styles['close-button']}
          onClick={() => setIsClosing(true)}
          name="close button"
        >
          <Close />
        </button>
        {children}
      </div>
    </div>
  )

  return (
    modalRoot && createPortal(modal, modalRoot)
  );
}

export default Modal;
